const e = {
    es: "MM/AA",
    en: "MM/YY",
    de: "MM/JJ",
    pt: "MM/AA"
}, n = {
    es: "Mostrar contrase\xf1a",
    en: "Show password",
    de: "Passwort anzeigen",
    pt: "mostrar senha"
}, t = {
    es: "Ocultar contrase\xf1a",
    en: "Hide password",
    de: "Passwort verbergen",
    pt: "esconder a senha"
}, o = {
    es: "Cargando",
    en: "Loading",
    de: "Wird gespeichert",
    pt: "Carregando"
}, s = {
    es: "Se abre en ventana nueva",
    en: "Opens in a new window",
    de: "Wird in neuem Fenster ge\xf6ffnet",
    pt: "Abre em nova janela"
}, r = {
    es: "P\xe1gina actual",
    en: "Current page",
    de: "Aktuelle Seite",
    pt: "P\xe1gina atual"
}, a = {
    es: "Cerrar",
    en: "Close",
    de: "Schlie\xdfen",
    pt: "Fechar"
}, i = {
    es: "Cancelar",
    en: "Cancel",
    de: "Abbrechen",
    pt: "Cancelar"
}, d = {
    es: "Aceptar",
    en: "Accept",
    de: "Akzeptieren",
    pt: "Aceitar"
}, c = {
    es: "Revisa los siguientes errores:",
    en: "Check the following errors:",
    de: "Pr\xfcfe folgende Fehler:",
    pt: "Confira os seguintes erros:"
}, l = {
    es: "opcional",
    en: "optional",
    de: "optional",
    pt: "opcional"
}, u = {
    es: "Este campo es obligatorio",
    en: "This field is required",
    de: "Das ist ein Pflichtfeld",
    pt: "Este campo \xe9 obrigat\xf3rio"
}, m = {
    es: "N\xfamero de tarjeta",
    en: "Card number",
    de: "Kartennummer",
    pt: "N\xfamero de cart\xe3o"
}, p = {
    es: "Caducidad",
    en: "Expiry",
    de: "Ablaufdatum",
    pt: "Expira\xe7\xe3o"
}, g = {
    es: "CVV",
    en: "CVV",
    de: "CVV",
    pt: "CVV"
}, C = {
    es: "CVV incorrecto",
    en: "Incorrect CVV",
    de: "Falsche CVV",
    pt: "CVV incorreto"
}, b = {
    es: "Mostrar ayuda CVV",
    en: "Show CVV help",
    de: "CVV-Hilfe anzeigen",
    pt: "Exibir ajuda CVV"
}, h = {
    es: "Ocultar ayuda CVV",
    en: "Hide CVV help",
    de: "CVV-Hilfe ausblenden",
    pt: "Ocultar ajuda CVV"
}, v = {
    es: "El CVV son los 3 \xfaltimos d\xedgitos del reverso de tu tarjeta",
    en: "The CVV is the 3 digits of the back of your card",
    de: "Der CVV-Code besteht aus den 3 Ziffern auf der Kartenr\xfcckseite",
    pt: "O CVV s\xe3o os 3  d\xedgitos do reverso de seu cart\xe3o"
}, f = {
    es: "Si es American Express, a\xf1ade los 4 d\xedgitos del anverso",
    en: "If it's American Express, add the 4-digit number on the front of the card",
    de: "Bei American Express 4-stelligen Code auf der R\xfcckseite hinzuf\xfcgen",
    pt: "Se for American Express, adicione os 4 d\xedgitos do anverso"
}, V = {
    es: "Fecha no v\xe1lida",
    en: "Invalid date",
    de: "Datum ung\xfcltig",
    pt: "Data inv\xe1lida"
}, L = {
    es: "No es un n\xfamero de tarjeta v\xe1lido",
    en: "The card number is not valid",
    de: "Kartennummer ung\xfcltig",
    pt: "N\xe3o \xe9 um n\xfamero de cart\xe3o v\xe1lido"
}, A = {
    es: "Fecha no permitida",
    en: "Invalid date",
    de: "Unzul\xe4ssiges Datum",
    pt: "Data n\xe3o permitida"
}, S = {
    es: "Email incorrecto",
    en: "Invalid email",
    de: "Falsche E-Mail-Adresse",
    pt: "Email incorreto"
}, M = {
    es: "IBAN incorrecto",
    en: "Incorrect IBAN",
    de: "Falsche IBAN",
    pt: "IBAN incorreto"
}, E = {
    es: "Cerrar",
    en: "Close",
    de: "Schlie\xdfen",
    pt: "Fechar"
}, y = {
    es: "Borrar b\xfasqueda",
    en: "Clear search",
    de: "Suche l\xf6schen",
    pt: "Apagar pesquisa"
}, B = {
    es: "men\xfa",
    en: "menu",
    de: "Men\xfc",
    pt: "menu"
}, $ = {
    es: "Abrir men\xfa de navegaci\xf3n",
    en: "Open navigation menu",
    de: "Navigationsmen\xfc \xf6ffnen",
    pt: "Abrir menu de navega\xe7\xe3o"
}, x = {
    es: "Cerrar men\xfa de navegaci\xf3n",
    en: "Close navigation menu",
    de: "Navigationsmen\xfc schlie\xdfen",
    pt: "Fechar menu de navega\xe7\xe3o"
}, D = {
    es: "Atr\xe1s",
    en: "Back",
    de: "Zur\xfcck",
    pt: "Voltar"
}, I = {
    es: "Borrar",
    en: "Clear",
    de: "L\xf6schen",
    pt: "Apagar"
}, N = {
    es: "siguiente",
    en: "next",
    de: "n\xe4chste",
    pt: "pr\xf3ximo"
}, P = {
    es: "anterior",
    en: "previous",
    de: "vorherige",
    pt: "anterior"
}, k = {
    es: "Reproducir",
    en: "Play",
    de: "Abspielen",
    pt: "Reproduzir"
}, F = {
    es: "Pausar",
    en: "Pause",
    de: "Pausieren",
    pt: "Pausar"
}, w = {
    es: "Continuar",
    en: "Continue",
    de: "Fortfahren",
    pt: "Continuar"
}, O = {
    es: "completo",
    en: "completed",
    de: "vollendet",
    pt: "conclu\xeddo"
}, T = {
    es: "Paso 1$s de 2$s",
    en: "Step 1$s of 2$s",
    de: "Schritt 1$s von 2$s",
    pt: "Etapa 1$s de 2$s"
}, R = {
    es: "D\xedgito 1$s de 2$s",
    en: "Digit 1$s of 2$s",
    de: "Ziffer 1$s von 2$s",
    pt: "D\xedgito 1$s de 2$s"
}, H = {
    es: "Borrar elemento",
    en: "Remove element",
    de: "Element entfernen",
    pt: "Remover elemento"
}, j = {
    es: "Aumentar valor",
    en: "Increase value",
    de: "Wert steigern",
    pt: "aumentar valor"
}, z = {
    es: "Disminuir valor",
    en: "Decrease value",
    de: "Wert verringern",
    pt: "diminuir valor"
}, q = {
    es: "cantidad",
    en: "quantity",
    de: "menge",
    pt: "quantidade"
}, W = {
    es: "m\xednimo",
    en: "minimum of",
    de: "minimal",
    pt: "m\xednimo"
}, K = {
    es: "m\xe1ximo",
    en: "maximum of",
    de: "maximal",
    pt: "m\xe1ximo"
}, Z = {
    es: "d",
    en: "d",
    de: "Tg.",
    pt: "d"
}, G = {
    es: "h",
    en: "h",
    de: "Std.",
    pt: "h"
}, J = {
    es: "min",
    en: "min",
    de: "Min.",
    pt: "min"
}, Q = {
    es: "s",
    en: "s",
    de: "Sek.",
    pt: "s"
}, Y = {
    es: "y",
    en: "and",
    de: "und",
    pt: "e"
}, U = {
    es: "d\xeda",
    en: "day",
    de: "Tag",
    pt: "dia"
}, X = {
    es: "d\xedas",
    en: "days",
    de: "Tage",
    pt: "dias"
}, _ = {
    es: "hora",
    en: "hour",
    de: "Stunde",
    pt: "hora"
}, ee = {
    es: "horas",
    en: "hours",
    de: "Stunden",
    pt: "horas"
}, ne = {
    es: "minuto",
    en: "minute",
    de: "Minute",
    pt: "minuto"
}, te = {
    es: "minutos",
    en: "minutes",
    de: "Minuten",
    pt: "minutos"
}, oe = {
    es: "segundo",
    en: "second",
    de: "Sekunde",
    pt: "segundo"
}, se = {
    es: "segundos",
    en: "seconds",
    de: "Sekunden",
    pt: "segundos"
}, re = {
    es: "min",
    en: "min",
    de: "Min.",
    pt: "min"
}, ae = {
    es: "seg",
    en: "sec",
    de: "Sek.",
    pt: "seg"
}, ie = {
    es: "Acciones",
    en: "Actions",
    de: "Aktionen",
    pt: "A\xe7\xf5es"
}, de = {
    es: "muy malo",
    en: "very bad",
    de: "sehr schlecht",
    pt: "muito ruim"
}, ce = {
    es: "malo",
    en: "bad",
    de: "schlecht",
    pt: "ruim"
}, le = {
    es: "regular",
    en: "regular",
    de: "regular",
    pt: "regular"
}, ue = {
    es: "bueno",
    en: "good",
    de: "gut",
    pt: "bom"
}, me = {
    es: "muy bueno",
    en: "very good",
    de: "sehr gut",
    pt: "muito bom"
}, pe = {
    es: "1$s de 2$s",
    en: "1$s out of 2$s",
    de: "1$s von 2$s",
    pt: "1$s de 2$s"
};
export { D as backNavigationBar, N as carouselNextButton, P as carouselPrevButton, I as clearButton, E as closeButtonLabel, x as closeNavigationMenu, z as counterDecreaseLabel, j as counterIncreaseLabel, K as counterMaxValue, W as counterMinValue, q as counterQuantity, H as counterRemoveLabel, d as dialogAcceptButton, i as dialogCancelButton, t as disablePasswordVisibility, n as enablePasswordVisibility, e as expirationDatePlaceholder, C as formCreditCardCvvError, g as formCreditCardCvvLabel, f as formCreditCardCvvTooltipAmex, v as formCreditCardCvvTooltipVisaMc, h as formCreditCardCvvTooltipVisaMcButtonClose, b as formCreditCardCvvTooltipVisaMcButtonOpen, V as formCreditCardExpirationError, p as formCreditCardExpirationLabel, L as formCreditCardNumberError, m as formCreditCardNumberLabel, A as formDateOutOfRangeError, S as formEmailError, c as formErrorsAlertMessage, u as formFieldErrorIsMandatory, l as formFieldOptionalLabelSuffix, M as formIbanError, y as formSearchClear, r as linkOpensInCurrentPage, s as linkOpensInNewTab, o as loading, B as menuLabelSuffix, a as modalClose, $ as openNavigationMenu, F as pauseIconButtonLabel, R as pinFieldInputLabel, k as playIconButtonLabel, O as progressBarCompletedLabel, T as progressBarStepLabel, ce as ratingBadLabel, ue as ratingGoodLabel, pe as ratingQuantitativeLabel, le as ratingRegularLabel, de as ratingVeryBadLabel, me as ratingVeryGoodLabel, w as sheetConfirmButton, ie as tableActionsHeaderLabel, Y as timerAnd, U as timerDayLongLabel, X as timerDaysLongLabel, Z as timerDaysShortLabel, re as timerDisplayMinutesLabel, ae as timerDisplaySecondsLabel, _ as timerHourLongLabel, ee as timerHoursLongLabel, G as timerHoursShortLabel, ne as timerMinuteLongLabel, te as timerMinutesLongLabel, J as timerMinutesShortLabel, oe as timerSecondLongLabel, se as timerSecondsLongLabel, Q as timerSecondsShortLabel };
